import React, { Component } from 'react';
import MenuBar from '../global/Menu'
import Patients from './patients/Patients'
import Financial from './Financial'
import ScheduleSecretary from './schedule/ScheduleSecretary'
import ScheduleFisioterapist from './schedule/ScheduleFisioterapist'
import AttendFisioterapist from './attend/AttendFisioterapist'
import Management from './management/Management'
import ClinicRegister from './clinic/ClinicRegister'
import Account from './account/Account';
import Faq from './faq/Faq';
import ClinicEdit from './ClinicEdit'
import ContactUs from './contactus/ContactUs'
import FirstAccess from '../panels/FirstAccess'
import Evolution from './evolution/Evolution';
import server from '../server';


class SystemHome extends Component{
    state = {
        page: "Minha Conta",
        first_access: false,
        open:false
    }

    componentWillMount(){
        if(server.user.firstAccess) this.setState({open:true});
        if(server.userType == "secretary") this.setState({page:"Agendar"});
        else if(server.userType == "doctor") this.setState({page:"Pacientes"})
        else if(server.userType == "fisioterapist") this.setState({page:"Agenda"});
        else if(server.userType == "patient") this.setState({page: "Evolução"});
    }

    reloadUser = () =>{
        server.get("users/" + server.user.id, (data) =>{
            server.user = data;
            this.setState({open:false,page:"Minha Conta"}, this.forceUpdate)
        })
    }

    render(){
        const pages = {
            "Agendar": <ScheduleSecretary alert={this.props.alert}/>,
            "Atender": <AttendFisioterapist alert={this.props.alert}/>,
            "Agenda":<ScheduleFisioterapist alert={this.props.alert}/>,
            "Financeiro": <Financial alert={this.props.alert}/>,
            "Clínica": <ClinicEdit alert={this.props.alert}/>,
            "Pacientes": <Patients alert={this.props.alert}/>,
            "Minha Conta": <Account alert={this.props.alert}/>,
            "Fale com a Blues": <ContactUs alert={this.props.alert}/>,
            "Cadastrar Clínica": <ClinicRegister alert={this.props.alert} />,
            "Suas Indicações": <Management alert={this.props.alert} />,
            "Suas Consultas": <Management alert={this.props.alert}/>,
            "Faq": <Faq/>,
            "Evolução": <Evolution alert={this.props.alert} />
        }

        return(
            <div style={{height:"100%"}}>
                <div style={this.state.open ? {} : {display:'none'}}>
                    <FirstAccess changePage={() => this.setState({page:2})} close={this.reloadUser}/>
                </div>
                <MenuBar currentPage={this.state.page} content={pages[this.state.page]} changePage={(name) => name == -1 ? this.props.logout() : this.setState({page:name})}/>
            </div>
        )
    }
}

export default SystemHome



// WEBPACK FOOTER //
// ./src/pages/SystemHome.js